'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Sparkles } from 'lucide-react';

import { useT } from '@/hooks';
import { colors } from '@/styles/theme';

/**
 * ReferralHeader Component
 * Hero section for the referral dashboard refactored to MUI.
 */
export const ReferralHeader: React.FC = () => {
  const { t } = useT();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 4 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          fontSize: '0.7rem',
          fontWeight: 800,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          color: 'primary.main',
        }}
      >
        <Sparkles size={14} />
        <span>{t('referral.program')}</span>
      </Box>
      <Typography
        variant="h3"
        fontWeight={800}
        sx={{
          letterSpacing: '-0.02em',
          color: 'text.primary',
          fontSize: { xs: '2rem', md: '2.5rem' },
        }}
      >
        {t('referral.tradeSmarter')}
        <Box
          component="span"
          sx={{
            background: `linear-gradient(to right, ${colors.info.main}, #6366F1)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {t('referral.earnTogether')}
        </Box>
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          maxWidth: 640,
          fontSize: '1rem',
          lineHeight: 1.5,
        }}
      >
        {t('referral.headerDesc')}
      </Typography>
    </Box>
  );
};
